import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs';

export function tooltipTemplate(
  this: TefComs4csMicroFrontend,
  stylecontext: string,
  title: string,
  description: string,
) {
  return html`<tef-coms-tooltip cloak context="${stylecontext}" placement="bottom">
    ${unsafeHTML(description)}
    <div slot="content">
      ${unsafeHTML(title)}
    </div>
  </tef-coms-tooltip>`;
}
